import ModalWindow from '../ModalWindow/ModalWindow';
import Tools from '../Tools/Tools';

let confirmDialogInstance = null;

/**
 * Potvrzovací modální dialog.
 * Singleton
 */
class ConfirmDialog {
	/**
	 * Vytvoří nový objekt nebo vrátí existující instanci dialogového potvrzovacího okna.
	 * @param {String} messageShort Krátká zpráva - nadpis
	 * @param {String} messageLong Dlouhá zpráva - odstavec menším písmem
	 * @param {String} confirmMessage Text potvrzovacího tlačítka
	 * @param {String} declineMessage Text odmítacího tlačítka
	 * @param {function} confirmCallback Callback se zavolá po potvrzení
	 */
	constructor(messageShort, messageLong, confirmMessage, declineMessage, confirmCallback) {
		if (confirmDialogInstance === null) {
			this.setProps(messageShort, messageLong, confirmMessage, declineMessage, confirmCallback);

			this.show();

			confirmDialogInstance = this;

			return this;
		} else {
			confirmDialogInstance.setProps(messageShort, messageLong, confirmMessage, declineMessage, confirmCallback);

			confirmDialogInstance.show();

			return confirmDialogInstance;
		}
	}

	setProps(messageShort, messageLong, confirmMessage, declineMessage, confirmCallback) {
		this._messageShort = messageShort;
		this._messageLong = messageLong;
		this._confirmMessage = confirmMessage;
		this._declineMessage = declineMessage;
		this._confirmCallback = confirmCallback;
	}

	show() {
		if (!this._confirmModalWrap) {
			this._createConfirmModal();
		} else {
			this._confirm.removeEventListener('click', this._onConfirm);
		}

		this._onConfirm = () => {
			this._confirmModal.close();
			this._confirmCallback();
		};

		this._confirm.addEventListener('click', this._onConfirm);
		this._confirmShortText.textContent = this._messageShort;
		this._confirmLongText.textContent = this._messageLong;
		this._confirm.textContent = this._confirmMessage;
		this._decline.textContent = this._declineMessage;
		this._confirmModal.openByCustomEvent(this._confirmModalWrap);
	}

	/**
	 * Vytvoří jedinou instanci modálního okna pro potvrzení akce.
	 */
	_createConfirmModal() {
		this._confirmModalWrap = Tools.createElement('div', {
			class: 'Modal Modal--default Modal--confirm',
			innerHTML: '<span class="Modal-close"></span>',
		});

		this._confirmShortText = Tools.createElement('h2', {
			class: 'Modal-title',
		});

		this._confirmLongText = Tools.createElement('p', {
			class: 'Modal-text',
		});

		const buttonsWrapper = Tools.createElement('div', {
			class: 'Modal-buttons',
		});

		this._confirm = Tools.createElement('button', {
			class: 'Modal-button--confirm',
		});

		this._decline = Tools.createElement('button', {
			class: 'Modal-button--decline',
		});

		this._decline.addEventListener('click', () => this._confirmModal.close());

		Tools.appendChilds(buttonsWrapper, this._confirm, this._decline);

		Tools.appendChilds(this._confirmModalWrap, this._confirmShortText, this._confirmLongText, buttonsWrapper);

		document.body.appendChild(this._confirmModalWrap);
		this._confirmModal = new ModalWindow();
	}
}

export default ConfirmDialog;
